<!-- Header -->
<div mat-dialog-title
	style="color: #A20000; text-align: center;">
	WARNING
</div>

<!-- Body -->
<mat-dialog-content>
	<div class="divTable" style="padding-left:10px; text-align:center;" *ngIf = "unsavedChanges == false">
		<div>
			<span style="color:darkred;"
				translate>
				Changes have been made to the query
			</span>
		</div>
		<div>
			<span style="font-style:italic;"
				translate>
				{{currentQuery.QueryName == 'My Defaults' ? 'My Default' : currentQuery.QueryName}}
			</span>
		</div>
		<div>
			<span style="color:darkred;"
				translate>
				but not saved.
			</span>
		</div>
	</div>
	<div *ngIf = "unsavedChanges == true">
		<div style="color:#a20000; text-align:center;" translate>
			Changes have been entered but not saved.
		</div>
		<div style="padding: 5px; margin-bottom: 15px; text-align: center;">
			If you continue without saving, the changes will be lost.
		</div>
	</div>
</mat-dialog-content>

<!-- Footer -->
<mat-dialog-actions style="position: sticky; min-width: 430px;"  *ngIf = "unsavedChanges == false">

	<!-- Left Buttons -->
	<tyl-button [image]="userCanOverwrite ? 'save.png' : 'save disabled.png'"
		label="Save Query"
		[disabled]="!userCanOverwrite"
		(clickEvent)="saveQuery()"></tyl-button>
	<tyl-button image="save and new.png"
		label="Save as New"
		(clickEvent)="saveAsNew()"></tyl-button>

	<!-- Right Buttons -->
	<div class="footerRight">
		<tyl-button image="next arrow.png"
			label="Continue without Saving"
			(clickEvent)="continueWithoutSaving()"></tyl-button>
		<tyl-button image="Cancel.png"
			label="Cancel"
			(clickEvent)="cancel()"></tyl-button>
	</div>
</mat-dialog-actions>

<mat-dialog-actions style="position: sticky; min-width: 430px;" *ngIf = "unsavedChanges == true">
    <tyl-button image="save black.png" label="Save and Continue" (clickEvent)="saveQuery()"></tyl-button>
    <!-- <tyl-button *ngIf="errors.length > 0 || preventSave" image="save disabled.png" label="Save and Continue" textColor="lightgrey" [disabled]="true"></tyl-button> -->
    <tyl-button image="next arrow.png" label="Continue without Saving" (clickEvent)="continueWithoutSaving()"></tyl-button>
    <tyl-button image="Cancel.png" label="Cancel" (clickEvent)="cancel()"></tyl-button>
</mat-dialog-actions>
